import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Controller } from "react-hook-form";


export default function MultiSelectAutocomplete({ onChange, control, ...props }) {
  return (
    <Controller
      as={
        <Autocomplete
          multiple={true}
          options={props.Values}
          getOptionLabel={(option) => option && option.label ? option.label : ''}
          id={props.id}
          Autocomplete={true}
          name={props.name}
          error={props.error}
          required={props.required}
          disabled={props.disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.label}
              error={props.error}
              required={props.required}
              name={props.name}
              disabled={props.disabled}
              margin="normal"
              variant="outlined"
              size="small" />
          )}
        />
      }
      onChange={([, data]) => {
        try {
          props.getValueChanged(data);
        } catch {
          //console.log("getvalueChnaged is not defined");
        }

        return (data);
      }}
      name={props.name}
      rules={props.rules}
      control={control}
      defaultValue={props.defaultValue}

    />
  );


}